import { render, staticRenderFns } from "./DestinationVideo.vue?vue&type=template&id=0caf7b89&scoped=true"
import script from "./DestinationVideo.vue?vue&type=script&lang=js"
export * from "./DestinationVideo.vue?vue&type=script&lang=js"
import style0 from "./DestinationVideo.vue?vue&type=style&index=0&id=0caf7b89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf7b89",
  null
  
)

export default component.exports